import { render } from "./ReceiptReport.vue?vue&type=template&id=1ce4547a&scoped=true"
import script from "./ReceiptReport.vue?vue&type=script&lang=js"
export * from "./ReceiptReport.vue?vue&type=script&lang=js"

import "./ReceiptReport.vue?vue&type=style&index=0&id=1ce4547a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce4547a"]])

export default __exports__